import { Switch, FormGroup, FormControlLabel } from "@mui/material";
import useBoolean from "hooks/useBoolean";

type SettingsSwitchProps = {
  initialChecked: boolean;
  onChange: (value: string) => void;
};

export default function SettingsSwitch({
  initialChecked,
  onChange,
}: SettingsSwitchProps) {
  const [checked, checkedActions] = useBoolean(initialChecked);
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            color="primary"
            onChange={(e) => {
              checkedActions.setValue(!checked);
              onChange((!checked).toString());
            }}
            value={checked.toString()}
          />
        }
        label={checked ? "True" : "False"}
      />
    </FormGroup>
  );
}
